/**
 * Whether the filing lane is on for this firm, read once per client for the screens that offer
 * a portal control beside an upload (Reconciliation, the Returns lifecycle strip). The Filing
 * screen reads the same state itself. Null while loading or when it could not be read — a
 * control then stays disabled rather than guessing the lane is on.
 */

import { useEffect, useState } from 'react'

import { type FilingLane, filing } from './api'

export function useFilingLane(clientId: string | null | undefined): FilingLane | null {
  const [lane, setLane] = useState<FilingLane | null>(null)
  useEffect(() => {
    let live = true
    if (!clientId) {
      setLane(null)
      return
    }
    filing
      .state(clientId)
      .then((body) => {
        if (live) setLane(body.data.lane)
      })
      .catch(() => {
        if (live) setLane(null)
      })
    return () => {
      live = false
    }
  }, [clientId])
  return lane
}
